import { render, staticRenderFns } from "./ShopTerms.vue?vue&type=template&id=7591e342&"
import script from "./ShopTerms.vue?vue&type=script&lang=js&"
export * from "./ShopTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports